// eslint-disable-next-line import/prefer-default-export
export const formElements = [
  "SLH-TEXTFIELD",
  "SLH-DATEPICKER",
  "SLH-DROPDOWN",
  "SLH-CHECKBOX",
  "SLH-SWITCH",
  "SLH-RADIO-GROUP",
  "SLH-FILE-INPUT",
  "SLH-TEXTAREA",
  "SLH-RICH-TEXT-EDITOR",
];
